import { useState } from 'react';
import PackageList from './package-list';
import Button from '../shared/buttons/button';
import ConfirmModal from '../shared/modals/confirm-modal';
import { PackageType } from '../../api/package';
import { useCart } from '../../context/cart/hooks';
import { useNavigate } from 'react-router-dom';
import { useCreateOrderMutation } from '../../hooks/react-query/use-order';

export type StorePropsType = {
  packages: PackageType[];
};

function Store(props: StorePropsType) {
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
  const cart = useCart();
  const navigate = useNavigate();
  const { mutateAsync: createOrder } = useCreateOrderMutation();

  const handleConfirm = async () => {
    setShowConfirmModal(false);
    const { id } = await createOrder({ packages: cart.map(pkg => pkg.id) });
    navigate(`/orders/${id}`);
  };

  return (
    <>
      <PackageList packages={props.packages} className='mt-8' />
      {cart.length > 0 && (
        <div className='fixed bottom-0 left-0 flex w-full flex-wrap items-center justify-center gap-2 bg-black bg-opacity-50 p-1.5'>
          <Button
            color='green'
            colorWeight={400}
            content='خرید بسته‌های انتخاب شده'
            onClick={() => setShowConfirmModal(true)}
          />
        </div>
      )}
      {showConfirmModal && (
        <ConfirmModal
          showModal={showConfirmModal}
          content={
            <p>
              <span>آیا از خرید </span>
              <span className='font-medium'>بسته‌های انتخاب شده</span>
              <span> مطمئن هستید؟</span>
            </p>
          }
          onConfirm={handleConfirm}
          onCancel={() => setShowConfirmModal(false)}
        />
      )}
    </>
  );
}

export default Store;
